import styled from "@rentiohq/web-theme";

export const CardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 0px;
`;

export const CardHeaderText = styled.div`
  flex: 1;
`;

export const CardTitle = styled.h3`
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 600;
`;

export const CardDescription = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${props => props.theme.getColor("gray", 600)};
`;

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const SwitchLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

export const ItemsContainer = styled.div<{ isDisabled?: boolean }>`
  padding: 0 0px 20px;
  opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};
  pointer-events: ${({ isDisabled }) => (isDisabled ? "none" : "auto")};
`;
